export const USER_JOINED_SITE = 'user-joined-site'
export const UNAUTHORIZED_USER_AUTHENTICATED = 'unauthorized-user-authenticated'
export const SET_USER = 'set-user'
export const SHOW_USER_FEEDBACK = 'show-user-feedback'
export const CLEAR_USER_FEEDBACK = 'clear-user-feedback'
export const USER_COMPLETED_DIALOG_REGISTRATION = 'user-completed-dialog-registration'
export const TOGGLE_EMAIL_CONFIRMATION_DIALOG = 'toggle-email-confirmation-dialog'
export const USER_FORGOT_CREDENTIAL = 'user-forgot-credential'
